import React from 'react';
import './Menu.css'; // Importa qui lo stile globale

// Questo componente 'Layout' farà da contenitore per tutte le tue pagine
function Layout({ children }) {
  return (
    // Questo div ha lo stile di base (sfondo, etc.)
    <div className="menu"> 
      {/* Qui potresti mettere un header o una navbar se ne avessi una */}
      
      <main>
        {/* {children} è un segnaposto dove React inserirà il componente della pagina specifica */}
        {children}
      </main>

      {/* Qui potresti mettere un footer comune a tutte le pagine */}
    </div>
  );
}

export default Layout;